import React from 'react'
import { render } from 'react-dom'
import Boot from "./components/layout/App/Boot";
import axios from './axios';
import store from "./store"
window.process = {};
axios.interceptors.response.use( response =>
{
    return response
}, error => {
    store.dispatch({ type: 'API_ERROR', payload: error });
    return Promise.reject(error);
});
render( <Boot />,  document.querySelector('#root') );
